import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-timepicker',
  templateUrl: './app-timepicker.component.html',
  styleUrls: ['./app-timepicker.component.scss']
})
export class AppTimepickerComponent implements OnChanges {

  public hours = [];
  public minutes = [];
  public selected_hour: number;
  public selected_minute: number;
  @Input() current: Date;
  @Input() disabled: boolean;
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    // for (let m = 0; m < 60; m++) {
    //   this.minutes.push(this.addZero(m));
    // }
    // for (let h = 0; h < 24; h++) {
    //   this.hours.push(this.addZero(h));
    // }
  }

  addZero(value) {
    value = parseInt(value, 10);
    let _value = value.toString();
    if (value < 10) {
      _value = '0' + value;
    }
    return _value;
  }

  increment(type, interval) {
    if (!this.disabled) {
      if (type === 'h') {
        if (this.selected_hour === 23 || this.selected_hour === 0 && interval < 0) {
          this.selected_hour = 0;
        } else { this.selected_hour = this.selected_hour + interval; }
        this.changed(this.selected_hour, this.selected_minute);
      }
      if (type === 'm') {
        if ((this.selected_minute <= 59 && this.selected_minute >= 55)
        ||  (this.selected_minute >= 0 && this.selected_minute <= 5 && interval < 0)) {
          this.selected_minute = 0;
        } else {
          this.selected_minute = this.selected_minute + interval;
        }
        // console.log(this.selected_hour, this.selected_minute);
        this.changed(this.selected_hour, this.selected_minute);
      }
    }
  }

  changed(hour, minute) {
    const date = moment(this.current);
    date.set('hour', hour);
    date.set('minute', minute);
    date.set('second', 0);
    this.notify.emit(date.toISOString());
  }

  ngOnChanges(changes: SimpleChanges) {
    let date = moment(this.current);
    if (!this.current) {
      date = moment();
      this.selected_hour = date.get('hour');
      this.selected_minute = date.get('minute');
    }
    this.selected_hour = this.current ? date.hours() : this.hours[0];
    this.selected_minute = this.current ? date.minutes() : this.minutes[0];
    // console.log('this.current', this.current);
    // console.log('this.selected_hour', this.selected_hour);
    // console.log('this.selected_minute', this.selected_minute);
  }

}
